<section *ngIf="currentOutlet !== 'userNotFound' && delayedRender && (currentOutlet === '' || !currentOutlet)">
  <div *ngIf="!isIframe">
    <searchbar-controller *ngIf="!isAccessRestrictedRoute"></searchbar-controller>
    <section class="content-container">
      <navbar-controller *ngIf="!isAccessRestrictedRoute"></navbar-controller>
      <router-outlet></router-outlet>
    </section>
    <app-loading-indicator></app-loading-indicator>
  </div>
</section>

<router-outlet name="userNotFound"></router-outlet>
